import React, { Component } from 'react'
import { Sidebar, NotFound } from '..'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'

import CardOferta from '../Card/CardOferta'
import InfiniteScroll from 'react-infinite-scroller'
import { Button } from 'loyal-react'
import queryString from 'query-string'

import '@loyal_template/search.css'

import { ComunidadeIuppService as Service } from 'features/Services/ComunidadeIupp'

class Search extends Component {
  constructor (props) {
    super()
    this.state = {
      showZipCode: true,
      locationActive: true,
      condition: false,
      NotFound: false,
      isLoading: false,
      filterSelected: {},
      hasMoreItems: true,
      Location: null,
      ordination: {
        DISTANCE: false,
        HIGHERDISCOUNTS: false
      },
      offers: [],
      filter: {
        pagination: {
          pageSize: 9,
          pageNumber: 1
        },
        filter: {
          chain: {
            ids: []
          },
          advertisementType: [0],
          geoNear: {
            maxDistance: 500000,
            location: {
              latitude: 0,
              longitude: 0
            }
          }
        }
      }
    }

    this.loadItems = this.loadItems.bind(this)
  }

  componentDidMount () {
    this.handleVerifyToken()
    this.handleGetCategories()

    setTimeout(() => {
      this.setFilterByQueryString()
    }, 300)
  }

  setFilterByQueryString = () => {
    let queryStringLocation =
      this.props.location && this.props.location.search.replace('?', '')

    let { zipcode, category, sort } = queryString.parse(queryStringLocation)

    category = category && [category]

    let mustFetch = true
    let mustChangeUrl = false
    this.setFilter(zipcode, category, sort, mustChangeUrl, mustFetch)
  }

  handleLocation = async filterSelected => {
    const selecteds = filterSelected || this.state.filterSelected
    if (selecteds.zipcode && selecteds.zipcode.length > 0) {
      const resultLocation = await Service.getLocation(selecteds.zipcode)
      this.setState({ locationActive: true, Location: resultLocation })
    } else {
      this.setState({ Location: {} })
    }
  }

  handleFilterChanged = (filterType, mustFetch = true) => e => {
    let filterValue
    let filterAction = 'update'
    let tagType = e.target ? String(e.target.type) : ''

    switch (tagType) {
      case 'checkbox': {
        filterValue = e.target.value
        filterAction = e.target.checked ? 'add' : 'remove'
        break
      }
      case 'text': {
        filterValue = e.target.value
        break
      }
      default: {
        if (e.target) {
          filterAction = e.target.getAttribute('action')
          filterValue = e.target.getAttribute('value')
        }
        break
      }
    }

    filterAction = filterAction || 'update'
    filterValue = filterValue || e

    let { zipcode, category, sort } = this.state.filterSelected

    switch (filterType) {
      case 'category': {
        category = filterAction === 'remove' ? '' : [filterValue]
        break
      }
      case 'sort': {
        sort = filterAction === 'remove' ? '' : [filterValue]
        this.handleOrdination(sort)
        break
      }
      case 'zipcode': {
        zipcode =
          filterAction === 'remove' ? '' : [filterValue.replace('-', '')]
        break
      }
    }

    let mustChangeUrl = true
    this.setFilter(zipcode, category, sort, mustChangeUrl, mustFetch)
  }

  setFilter = async (zipcode, category, sort, mustChangeUrl, mustFetch) => {
    let filterSelected = {
      zipcode: zipcode,
      category: category,
      sort: sort
    }

    if (mustChangeUrl) {
      this.setQueryString(filterSelected)
    }
    this.setState({ filterSelected: filterSelected })

    if (mustFetch) {
      const pagination = {
        pageSize: 9,
        pageNumber: 1
      }

      let geoNear = {}
      if (
        window.sessionStorage.getItem('lat') &&
        window.sessionStorage.getItem('lng')
      ) {
        this.setState({ locationActive: true })
        geoNear = {
          maxDistance: 500000,
          location: {
            latitude: window.sessionStorage.getItem('lat'),
            longitude: window.sessionStorage.getItem('lng')
          }
        }
      }
      if (filterSelected.zipcode) {
        await this.handleLocation(filterSelected)
        let location =
          this.state.Location &&
          this.state.Location.data &&
          this.state.Location.data.objectReturn &&
          this.state.Location.data.objectReturn.location
        geoNear = {
          maxDistance: 500000,
          location: {
            latitude: location && location.lat,
            longitude: location && location.lng
          }
        }
      } else {
        if (
          !window.sessionStorage.getItem('lat') &&
          !window.sessionStorage.getItem('lng')
        ) {
          this.setState({ locationActive: true })
        }
      }
      const payload = {
        pagination: pagination,
        filter: {
          advertisementType: [0],
          chain: {
            categories: filterSelected.category
          },
          geoNear: geoNear
        }
      }
      this.setState({ offers: [], filter: payload, isLoading: true })
      setTimeout(() => {
        this.handleGetOffers()
      }, 1000)
    }
  }

  setQueryString = filterSelected => {
    let filterQueryString = ''
    Object.keys(filterSelected).map(key => {
      let filterQS = filterSelected[key]
      if (filterQS !== undefined && filterQS.toString() !== '') {
        filterQueryString +=
          (filterQueryString ? '&' : '') + key + '=' + filterQS.toString()
      }
    })

    let urlChanged =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      filterQueryString
    window.history.pushState({ path: urlChanged }, '', urlChanged)
  }

  handleOrdination (type) {
    switch (type) {
      case 'DISTANCE':
        this.setState({
          ordination: {
            DISTANCE: true,
            HIGHERDISCOUNTS: false
          }
        })
        break
      case 'HIGHERDISCOUNTS':
        this.setState({
          ordination: {
            DISTANCE: false,
            HIGHERDISCOUNTS: true
          }
        })
        break

      default:
        this.setState({
          ordination: {
            DISTANCE: false,
            HIGHERDISCOUNTS: false
          }
        })
        break
    }
  }

  handleFilter = () => {
    this.setState({ condition: !this.state.condition })
  }
  loadItems () {
    if (!this.state.isLoading) {
      const pagination = {
        pageSize: 9,
        pageNumber: this.state.filter.pagination.pageNumber + 1
      }
      const payload = {
        pagination: pagination,
        filter: this.state.filter.filter
      }
      this.setState({ filter: payload })
      this.handleGetOffers().catch(() => this.setState({ NotFound: false }))
    }
  }
  handleVerifyToken = async () => {
    await Service.tokenVerify()
  }
  handleGetOffers = async () => {
    await Service.getOffers(this.state.filter)
      .then(resultOffers => {
        if (resultOffers.data.objectReturn.data.length > 0) {
          const offers =
            (resultOffers &&
              resultOffers.data.objectReturn &&
              resultOffers.data.objectReturn.data) ||
            []
          this.setState({
            offers: this.state.offers.concat(offers),
            isLoading: false,
            NotFound: false
          })
        } else {
          this.setState({ hasMoreItems: false, isLoading: false })
          if (this.state.offers.length > 0) {
            this.setState({ NotFound: false })
          } else {
            this.setState({ NotFound: true })
          }
        }
      })
      .catch(() => this.setState({ NotFound: false }))
  }
  handleGetCategories = async () => {
    const resultCategories = await Service.getCategories()
    this.setState({
      categories: resultCategories && resultCategories.data.objectReturn
    })
  }

  render () {
    const productList = this.state.offers
    return (
      <div className={`showcase-lazy container-fluid showcase`}>
        <div className='container mt-5 mt-md-0 pt-4 pt-sm-5'>
          <div className={`row`}>
            <div className='container-results col-12 pb-2 py-md-2 d-flex d-md-flex'>
              <div className='row w-100'>
                <div className='col-12'>
                  <h2 className='txt-font-body color-title pb-half'>
                    comunidade
                  </h2>
                  <p>
                    <strong>{productList ? productList.length : 'xx'}</strong>{' '}
                    oferta(s) encontrada(s)
                  </p>
                </div>
              </div>
            </div>

            <div
              className={`col-12 px-0 pt-0 pb-2 ${
                this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
              }`}
            >
              <div className='row'>
                <div className='col-12 px-0'>
                  <Button
                    id={'button-voltar-mobile'}
                    name={'BUTTON'}
                    text='Voltar'
                    iconName='icon_left icon-sm'
                    className='col-12 btn-sm'
                    onClick={this.handleFilter}
                  />
                </div>
              </div>
            </div>
            <div
              className={`col-12 px-0 pt-0 pb-2 ${
                !this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
              }`}
            >
              <Button
                id={'button-filtrar-mobile'}
                name={'BUTTON'}
                text='Filtrar'
                iconName='icon_filter'
                className='col-12 btn-sm '
                onClick={this.handleFilter}
              />
            </div>
            <Sidebar
              categories={this.state.categories || []}
              handleFilterChanged={this.handleFilterChanged}
              filterSelected={this.state.filterSelected}
              pageType='search'
              isLoading={this.state.isLoading}
              ordination={this.state.ordination}
              showZipCode={this.state.showZipCode}
              term={this.state.term}
              className={`${
                this.state.condition
                  ? 'd-block d-md-block'
                  : 'd-none d-md-block'
              }`}
            />

            <div
              className={`container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 ${
                !this.state.condition
                  ? 'd-block d-md-block'
                  : 'd-none d-md-block'
              }`}
            >
              {!this.state.NotFound ? (
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  loadMore={this.loadItems}
                  hasMore={this.state.hasMoreItems}
                  loader={
                    <Button loading text='Carregando' className='btn-flat' />
                  }
                >
                  <div className='row'>
                    {productList &&
                      productList.map((product, ix) => (
                        <CardOferta
                          {...product}
                          key={ix}
                          offer={product}
                          location={this.state.locationActive}
                        />
                      ))}
                  </div>
                </InfiniteScroll>
              ) : (
                <NotFound />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      sku: PropTypes.string.isRequired
    })
  }),
  location: PropTypes.string
}

const mapStateToProps = ({ router }) => {
  return { location: router && router.location }
}

export default connect(mapStateToProps)(Search)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Search/Search.js